import type { ScreenModule } from "../../../app/screen-module";
import { NotificationsPage } from "../SettingsPages";

export default {
	id: "end-user.notifications",
	path: "/app/notifications",
	area: "end-user",
	navGroup: "自分の設定",
	label: "お知らせ",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: NotificationsPage,
} satisfies ScreenModule;
